import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-drivingDifficultyWindIcon",
  "use": "icon-drivingDifficultyWindIcon-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-drivingDifficultyWindIcon\"><path d=\"M6.694 3.111a1.333 1.333 0 1 1 .994 2.222h-6m7.006 7.556a1.333 1.333 0 1 0 .994-2.222h-8m9.842-6A2 2 0 1 1 13.02 8H1.689\" stroke=\"#4C556C\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol